import React from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Badge
} from 'reactstrap';

const DataReceptionTab = ({ deal, formatCurrency, formatDate }) => {

  return (
    <Row>
      <Col>
        {/* Business Information */}
        <Card className="shadow-sm mb-3">
          <CardHeader className="bg-info text-white">
            <div className="d-flex align-items-center">
              <i className="ni ni-briefcase-24 mr-2" />
              <h5 className="mb-0">General Information</h5>
            </div>
          </CardHeader>
            <CardBody className="p-4">
              {/* Form Grid - 2 columns */}
              <Row>
                <Col md="6" className="mb-2">
                  <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                    <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>Legal Name</label>
                    <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                      {deal.legalName || 'N/A'}
                    </div>
                  </div>
                </Col>
                <Col md="6" className="mb-2">
                  <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                    <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>DBA Name</label>
                    <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                      {deal.dbaName || 'N/A'}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md="6" className="mb-2">
                  <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                    <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>Federal Tax ID</label>
                    <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                      {deal.federalTaxId || 'N/A'}
                    </div>
                  </div>
                </Col>
                <Col md="6" className="mb-2">
                  <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                    <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>State of Formation</label>
                    <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                      {deal.stateOfInc || 'N/A'}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md="6" className="mb-2">
                  <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                    <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>Industry</label>
                    <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                      {deal.industry || 'N/A'}
                    </div>
                  </div>
                </Col>
                <Col md="6" className="mb-2">
                  <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                    <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>Business Structure</label>
                    <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                      {deal.businessStructure || 'N/A'}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md="6" className="mb-2">
                  <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                    <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>Requested Amount </label>
                    <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                      {formatCurrency(deal.requestedAmount)}
                    </div>
                  </div>
                </Col>
                <Col md="6" className="mb-2">
                  <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                    <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>Phone Number</label>
                    <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                      {deal.phoneNumber || 'N/A'}
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Note: Addresses are within owners in this response structure, not at deal level */}
              {/* Owners Section */}
              {deal.owners && deal.owners.length > 0 && (
                <div
                  className="mb-4"
                  style={{
                    borderTop: '2px solid #dee2e6',
                    paddingTop: '20px',
                    marginTop: '20px',
                  }}
                >
                  <h6
                    className="text-muted mb-3"
                    style={{ fontSize: '1rem', fontWeight: '600' }}
                  >
                    OWNERS ({deal.owners.length})
                  </h6>

                  {deal.owners.map((owner, index) => {
                    const primaryEmail = owner.contacts?.find(
                      (c) => c.type === 'EMAIL' && c.isPrimary && !c.deleted
                    );
                    const primaryPhone = owner.contacts?.find(
                      (c) => c.type === 'PHONE' && c.isPrimary && !c.deleted
                    );

                    return (
                      <div key={owner.id || index}>
                        {/* Información del Owner */}
                        <Row>
                          <Col md="6" className="mb-2">
                            <div
                              className="d-flex align-items-center"
                              style={{
                                borderBottom: '1px solid #dee2e6',
                                paddingBottom: '8px',
                                marginBottom: '8px',
                              }}
                            >
                              <label
                                className="form-label text-muted mb-0"
                                style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}
                              >
                                Name
                              </label>
                              <div
                                className="text-dark ml-3"
                                style={{ fontSize: '0.8rem', wordWrap: 'break-word' }}
                              >
                                {owner.firstName} {owner.middleName && `${owner.middleName} `}
                                {owner.lastName}
                              </div>
                            </div>
                          </Col>

                          <Col md="6" className="mb-2">
                            <div
                              className="d-flex align-items-center"
                              style={{
                                borderBottom: '1px solid #dee2e6',
                                paddingBottom: '8px',
                                marginBottom: '8px',
                              }}
                            >
                              <label
                                className="form-label text-muted mb-0"
                                style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}
                              >
                                SSN
                              </label>
                              <div
                                className="text-dark ml-3"
                                style={{ fontSize: '0.8rem', wordWrap: 'break-word' }}
                              >
                                {owner.socialSecurityNumber
                                  ? `***-**-${owner.socialSecurityNumber.slice(-4)}`
                                  : 'N/A'}
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="6" className="mb-2">
                            <div
                              className="d-flex align-items-center"
                              style={{
                                borderBottom: '1px solid #dee2e6',
                                paddingBottom: '8px',
                                marginBottom: '8px',
                              }}
                            >
                              <label
                                className="form-label text-muted mb-0"
                                style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}
                              >
                                Birth Date
                              </label>
                              <div
                                className="text-dark ml-3"
                                style={{ fontSize: '0.8rem', wordWrap: 'break-word' }}
                              >
                                {owner.birthDate ? formatDate(owner.birthDate) : 'N/A'}
                              </div>
                            </div>
                          </Col>

                          <Col md="6" className="mb-2">
                            <div
                              className="d-flex align-items-center"
                              style={{
                                borderBottom: '1px solid #dee2e6',
                                paddingBottom: '8px',
                                marginBottom: '8px',
                              }}
                            >
                              <label
                                className="form-label text-muted mb-0"
                                style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}
                              >
                                Ownership
                              </label>
                              <div
                                className="text-dark ml-3"
                                style={{ fontSize: '0.8rem', wordWrap: 'break-word' }}
                              >
                                {owner.ownershipPercentage
                                  ? `${owner.ownershipPercentage}% `
                                  : '100% '}
                              </div>
                            </div>
                          </Col>
                        </Row>

                        {/* Aquí colocamos Address y Contact Information en la misma fila */}
                        <Row className="align-items-start">
                          {/* Address: ocupa más espacio */}
                          <Col md="6" className="mb-2">
                            <div
                              className="d-flex align-items-center"
                              style={{
                                borderBottom: '1px solid #dee2e6',
                                paddingBottom: '8px',
                                marginBottom: '8px',
                              }}
                            >
                              <label
                                className="form-label text-muted mb-0"
                                style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}
                              >
                                Address
                              </label>
                              <div
                                className="text-dark ml-3"
                                style={{ fontSize: '0.8rem', wordWrap: 'break-word' }}
                              >
                                {owner.addresses && owner.addresses.length > 0
                                  ? `${owner.addresses[0].street1} ${
                                      owner.addresses[0].street2
                                        ? `, ${owner.addresses[0].street2}`
                                        : ''
                                    } ${owner.addresses[0].city}, ${owner.addresses[0].state} ${
                                      owner.addresses[0].zipCode
                                    }`
                                  : 'N/A'}
                              </div>
                            </div>
                          </Col>

                          {/* Contact Information compacto a la derecha */}
                          <Col md="6" className="mb-2">
                            <div
                              className="p-2 rounded"
                              style={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #dee2e6',
                                boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
                              }}
                            >
                              <div style={{ marginBottom: '6px' }}>
                                <h6
                                  className="text-muted mb-0 text-center "
                                  style={{ fontSize: '0.85rem', fontWeight: 'bold',  }}
                                >
                                  Contact Information
                                </h6>
                              </div>

                              <div
                                className="d-flex justify-content-between"
                                style={{ fontSize: '0.78rem', color: '#495057' }}
                              >
                                <div style={{ minWidth: '40%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                  <span className="text-muted" style={{ fontSize: '0.76rem', marginRight: '6px' }}>Phone</span>
                                  <div style={{ display: 'inline' }}>
                                    {primaryPhone?.value || 'N/A'}
                                  </div>
                                </div>

                                <div style={{ minWidth: '55%', textAlign: 'right', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                  <span className="text-muted" style={{ fontSize: '0.76rem', marginRight: '6px' }}>Email:</span>
                                  <div style={{ display: 'inline' }}>
                                    {primaryEmail?.value || 'N/A'}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        {index < deal.owners.length - 1 && <hr className="my-4" />}
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Bank Accounts Section */}
              {deal.bankAccounts && deal.bankAccounts.length > 0 && (
                <div className="mb-4" style={{ borderTop: '2px solid #dee2e6', paddingTop: '20px', marginTop: '20px' }}>
                  <h6 className="text-muted mb-3" style={{ fontSize: '1rem', fontWeight: '600' }}>BANK ACCOUNTS</h6>
                  {deal.bankAccounts.map((account, index) => (
                    <div key={account.id || index}>
                      <Row>
                        <Col md="6" className="mb-2">
                          <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                            <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>Bank Name</label>
                            <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                              {account.bankName || 'N/A'}
                            </div>
                          </div>
                        </Col>
                        <Col md="6" className="mb-2">
                          <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                            <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>Account Name</label>
                            <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                              {account.accountName || 'N/A'}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6" className="mb-2">
                          <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                            <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>Account Number</label>
                            <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                              {account.number ? `****${account.number.slice(-4)}` : 'N/A'}
                            </div>
                          </div>
                        </Col>
                        <Col md="6" className="mb-2">
                          <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                            <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>Routing Number</label>
                            <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                              {account.routingNumber || 'N/A'}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6" className="mb-2">
                          <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                            <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>Bank City</label>
                            <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                              {account.bankCity || 'N/A'}
                            </div>
                          </div>
                        </Col>
                        <Col md="6" className="mb-2">
                          <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px', marginBottom: '8px' }}>
                            <label className="form-label text-muted mb-0" style={{ fontSize: '0.8rem', fontWeight: '500', minWidth: '120px' }}>Bank Location</label>
                            <div className="text-dark ml-3" style={{ fontSize: '0.8rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                              {account.bankCity && account.bankState ? 
                                `${account.bankCity}, ${account.bankState}, ${account.bankCountry || 'USA'}` : 
                                'N/A'
                              }
                            </div>
                          </div>
                        </Col>
                      </Row>
                      {index < deal.bankAccounts.length - 1 && <hr className="my-4" />}
                    </div>
                  ))}
                </div>
              )}

            </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default DataReceptionTab;
